<template>
  <div class="POIinterfacebottom noclick" v-if="markerdata.length > 0">
    <div class>
      <div
        class="btn-group enableclick"
        role="group"
        v-if="poiInterface.infoVisible && markerdata.length > 1 && !poiInterface.profsVisible"
      >
        <button
          class="btn btn-primary btn-sm btn-iconbtn button-h-sm"
          @click="prevpraktijk"
          v-bind:disabled="poiInterface.leftButtonDisabled"
        >
          <i class="fa fa-caret-left caretsize" aria-hidden="true"></i>
        </button>
        <button class="btn btn-primary btn-sm btn-icontextbtn button-h-sm">
          {{ poiInterface.poiselected + 1 }} {{ $store.state.translation[2030] }} {{ markerdata.length }}
        </button>
        <button
          class="btn btn-primary btn-sm btn-iconbtn button-h-sm"
          @click="nextpraktijk"
          v-bind:disabled="poiInterface.rightButtonDisabled"
        >
          <i class="fa fa-caret-right caretsize" aria-hidden="true"></i>
        </button>
      </div>
      <!-- v-if="!showfysioview" -->
      <div class="infoview praktijkview enableclick selecttext scrollInterfacePoi" v-if="!poiInterface.profsVisible">
        <div class="fysiodatawrap praktijkview">
          <div class="infoviewhead">{{ markerdata[poiInterface.poiselected].tblPointOfInterestName }}</div>
          <address>
            <div class="poiadres" v-if="!markerdata[poiInterface.poiselected].tblPointOfInterestAddressFull">
              {{ markerdata[poiInterface.poiselected].tblPointOfInterestStreet }}
              {{ markerdata[poiInterface.poiselected].tblPointOfInterestNumber }}
              {{ markerdata[poiInterface.poiselected].tblPointOfInterestNumberAddition }}
            </div>
            <div class="poiadres" v-else>
              {{ markerdata[poiInterface.poiselected].tblPointOfInterestAddressFull }}
            </div>            

            <div class="poiadres2">
              {{ markerdata[poiInterface.poiselected].tblPointOfInterestPostalCode }}
              {{ markerdata[poiInterface.poiselected].tblPointOfInterestCity }}
            </div>

            <div class="poitelnr">
                {{ markerdata[poiInterface.poiselected].tblPointOfInterestTelephone }}
            </div>

            <div class="poiwebsite">
              <a
                v-if="markerdata[poiInterface.poiselected].tblPointOfInterestWebsite"
                target="_blank"
                v-bind:href="markerdata[poiInterface.poiselected].tblPointOfInterestWebsite"
                >{{ $store.state.translation[8944] }}</a
              >
            </div>
            <div class="poiemail">
              <a
                v-if="markerdata[poiInterface.poiselected].tblPointOfInterestEmail"
                v-bind:href="'mailto:' + markerdata[poiInterface.poiselected].tblPointOfInterestEmail"
                >{{ $store.state.translation[14164] }}</a
              >
            </div>
          </address>
        </div>
      </div>
      <div class="infoview enableclick">
        <button
          type="button"
          @click.prevent="showProfs(markerdata[poiInterface.poiselected].tblPointOfInterestID)"
          class="btn btn-primary btn-sm button-h-sm btn-icontextbtn btn-block"
        >
          <i
            class="fa caretsize pull-left poscaret-down"
            :class="[poiInterface.profsVisible ? 'fa-caret-down' : 'fa-caret-up']"
            aria-hidden="true"
          ></i>
          <span>{{ $store.state.translation[14133] }}</span>
        </button>
        <!-- PE-18068 opmaak zoeken op kaart verbeteren. Omgezet naar div's met row class en col-4 / col-8. en margin10.  -->
        <div v-if="poiInterface.profsVisible">
          <div v-if="poiProf.length != 0" class="col-md-12 scrollInterfacePoi">
            <div v-for="(prof, index) in poiProf" :key="'prof' + index" class="margin20 margin20bottom">
              <div class="row">
                <div class="col-md-12">
                  <font-awesome-icon :icon="['fas', 'user']" size="lg" />&nbsp;
                  <strong>{{ prof.tblPersonName }}</strong>
                </div>
              </div>
              <div v-for="(meta, index2) in poiProfMeta(prof.tblPersonID)" :key="'meta' + index2" class="row margin10">
                <div class="col-md-4">
                  <span>{{ meta.metaName }}</span>
                </div>
                <div class="col-md-8">
                  <span v-html="meta.tblPersonInfoRequiredValueValue"></span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
'use strict'

import { mapGetters, mapActions, mapMutations } from 'vuex'
import { FAMixin } from 'pevueglobal'
export default {
  mixins: [FAMixin],
  props: {
    markerdata: {
      type: Array,
      default() {
        return []
      },
    },
  },
  data() {
    return {}
  },
  created() {},
  methods: {
    ...mapActions('PointsOfInterest', ['PEapi_PointsOfInterest_Profs']),
    ...mapMutations('PointsOfInterest', [
      'leftButtonDisabled',
      'rightButtonDisabled',
      'poiSelectedIncrease',
      'poiSelectedDecrease',
      'profSelectedIncrease',
      'profSelectedDecrease',
      'toggleProfsVisible',
    ]),
    showProfs(poiID) {
      if (this.poiInterface.profsVisible === true) {
        this.toggleProfsVisible(false)
      } else {
        this.PEapi_PointsOfInterest_Profs({ poiID, profgroupID: this.$route.params.profgroupID })
      }
    },
    nextpraktijk: function () {
      if (this.poiInterface.poiselected < this.markerdata.length - 1) {
        if (this.poiInterface.poiselected === this.markerdata.length - 2) {
          this.rightButtonDisabled(true)
        }
        this.leftButtonDisabled(false)

        this.poiSelectedIncrease()
      } else {
        this.rightButtonDisabled(true)
      }
    },
    prevpraktijk: function () {
      if (this.poiInterface.poiselected > 0) {
        this.poiSelectedDecrease()
        if (this.poiInterface.poiselected === 0) {
          this.leftButtonDisabled(true)
        }
        this.rightButtonDisabled(false)
      } else {
        this.leftButtonDisabled(true)
      }
    },
  },
  computed: {
    ...mapGetters('PointsOfInterest', ['poiInterface', 'poiProf', 'poiProfMeta']),
  },
}
</script>
                                    
